class CartTool extends HTMLElement {
  constructor() {
    super();
    // const buttons = this.querySelectorAll('.cartTool-item');
    // buttons.forEach((button) => {
    //   button.addEventListener('click',(event) => {
    //     const id = event.target.dataset.popup;
    //     document.getElementById(id).classList.add('show');
    //     document.querySelector('.previewCart').classList.add('active-tool');
    //   })
    // })
    
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      // document.querySelector('.popup-toolDown.show').classList.remove('show');
      // document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();

    const input = this.querySelector('input[name="discount"]');
    const button = this.querySelector('[data-update-coupon]');

    const storedDiscount = localStorage.getItem('storedDiscount');

    if (storedDiscount) {
      input.value = storedDiscount;
      button.innerText = button.dataset.cancelText;
      button.classList.add('ax-has-coupon');
    }

    button.addEventListener('click', () => {
      this.val = input.value;

      // Coupon déjà appliqué → annulation
      if (button.classList.contains('ax-has-coupon')) {
        this.val = '';
        input.value = '';

        localStorage.removeItem('storedDiscount');

        fetch('/discount/CLEAR')
          .then((response) => response.text())
          .then(() => {
            button.classList.remove('ax-has-coupon');
            button.innerText = button.dataset.saveText;

            $('[data-cart-quantity]').trigger('change');
          });

        return;
      }

      // Application du coupon
      if (this.val) {
        localStorage.setItem('storedDiscount', this.val);

        fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then(() => {
            button.classList.add('ax-has-coupon');
            button.innerText = button.dataset.cancelText;

            $('[data-cart-quantity]').trigger('change');
          });
      }
    });
  }
}

customElements.define('coupon-code', CouponCode);